import api from './api';

/**
 * Servicio para gestionar notificaciones
 */
const notificacionService = {
  /**
   * Obtener todas las notificaciones del usuario
   * @param {Object} params - Parámetros de consulta
   * @param {boolean} params.leida - Filtrar por estado leída
   * @param {number} params.limit - Límite de resultados
   * @param {number} params.page - Página actual
   */
  obtenerNotificaciones: async (params = {}) => {
    const response = await api.get('/notificaciones', { params });
    return response.data;
  },

  /**
   * Obtener solo notificaciones no leídas
   */
  obtenerNoLeidas: async () => {
    const response = await api.get('/notificaciones/no-leidas');
    return response.data;
  },

  /**
   * Obtener contador de notificaciones no leídas
   */
  contarNoLeidas: async () => {
    const response = await api.get('/notificaciones/contador');
    return response.data;
  },

  /**
   * Marcar una notificación como leída
   * @param {string} id - ID de la notificación
   */
  marcarComoLeida: async (id) => {
    const response = await api.patch(`/notificaciones/${id}/leer`);
    return response.data;
  },

  /**
   * Marcar todas las notificaciones como leídas
   */
  marcarTodasComoLeidas: async () => {
    const response = await api.patch('/notificaciones/leer-todas');
    return response.data;
  },

  /**
   * Eliminar una notificación
   * @param {string} id - ID de la notificación
   */
  eliminarNotificacion: async (id) => {
    const response = await api.delete(`/notificaciones/${id}`);
    return response.data;
  },

  /**
   * Crear una notificación (admin/entrenador)
   * @param {Object} datos - Datos de la notificación
   */
  crearNotificacion: async (datos) => {
    const response = await api.post('/notificaciones', datos);
    return response.data;
  },
};

export default notificacionService;
